import React from "react";
import { useNavigate } from "react-router-dom";
import { QuesLoader } from "../../util/common";
import AnswerAlphaNumeric from "./answersAlphaNumeric";
import QuestionAlphaNumeric from "./questionAlphaNumeric";

const TestTakerQuestions29 = (props) => {
    const {
        dataQuestion,
        fullData,
        label_text,
        isWarmUp,
        moveNextQuest,
        addKeyPressed,
        phrases,
        phase,
    } = props;
    const navigate = useNavigate();

    if (isWarmUp && !dataQuestion) {
        return navigate("/" + sessionStorage.getItem("urlParams"));
    }

    const inputSize = dataQuestion.length;

    return (
        <form
            id="inputForm"
            className="g-item_12  g2 flex flex_col_mobile align-self-stretch align-items_start position_relative"
        >
            <QuesLoader show={phase === "showing-loader"} />
            <QuestionAlphaNumeric
                phrases={phrases}
                questLabels={fullData.questLabels}
                dataQuestion={dataQuestion}
                phase={phase}
            />
            <AnswerAlphaNumeric
                phrases={phrases}
                questLabels={fullData.questLabels}
                eventListenTab={(e, id) => {
                    if (id === inputSize) {
                        e.preventDefault();
                        moveNextQuest();
                    }
                }}
                keyCount={() => addKeyPressed()}
                phase={phase}
            />
        </form>
    );
};

export default TestTakerQuestions29;
